import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// node配置信息读取
const v2CoreGetLocalConfig = obj => new Promise((resolve, reject) => {
    const {
        nodeReadForm,
        token
    } = obj;
    request({
        url: apis.war_v2_core_get_local_config + '?token=' + token,
        data: nodeReadForm
    }).then(res => {
        resolve(res);
    })
});

// 运行coreRun
const v2CoreRun = obj => new Promise((resolve, reject) => {
    const {
        nodeCoreRunForm,
        token
    } = obj;
    request({
        url: apis.war_v2_core_run + '?token=' + token,
        data: nodeCoreRunForm
    }).then(res => {
        resolve(res);
    })
});


export default {
    v2CoreGetLocalConfig,
    v2CoreRun
}



// WEBPACK FOOTER //
// ./src/service/war_api.js